interface InsideIconProps {
  width?: number | string;
  height?: number | string;
  color?: string;
  className?: string;
}

const InsideIcon: React.FC<InsideIconProps> = ({ width = 35, height = 24, color = '#91B1BE', className = '' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 36 36'
    fill='none'
    className={className}
  >
    <g className='dark:child:stroke-primary-500' clipPath='url(#clip0_4_311)'>
      <path
        d='M12.263 15.328L10.722 13.86C9.4723 14.4623 8.06607 14.6605 6.69857 14.4271C5.33108 14.1937 4.0702 13.5403 3.09101 12.5576C2.11183 11.5749 1.46294 10.3117 1.23445 8.94336C1.00597 7.57504 1.20922 6.16953 1.816 4.922L3.916 7.006C4.12092 7.21806 4.36602 7.38718 4.637 7.50351C4.90798 7.61984 5.19942 7.68103 5.4943 7.68353C5.78918 7.68603 6.08161 7.62978 6.35452 7.51807C6.62744 7.40635 6.87537 7.2414 7.08386 7.03285C7.29234 6.82429 7.45721 6.57631 7.56884 6.30336C7.68047 6.03041 7.73663 5.73797 7.73404 5.44308C7.73144 5.1482 7.67015 4.85679 7.55374 4.58585C7.43733 4.3149 7.26812 4.06986 7.056 3.865L4.971 1.78C6.21829 1.18949 7.61735 0.998046 8.97742 1.23176C10.3375 1.46548 11.5924 2.11299 12.571 3.086'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M23.289 20.054L24.639 21.39C25.8829 20.7983 27.2793 20.6057 28.637 20.8386C29.9946 21.0714 31.247 21.7184 32.2227 22.6907C33.1984 23.6631 33.8495 24.9133 34.0869 26.2702C34.3244 27.627 34.1365 29.0241 33.549 30.27L31.45 28.184C31.0332 27.7677 30.4681 27.5341 29.8791 27.5345C29.29 27.5349 28.7253 27.7692 28.309 28.186C27.8927 28.6028 27.6591 29.1679 27.6595 29.7569C27.6599 30.346 27.8942 30.9107 28.311 31.327L30.395 33.411C29.1477 34.0015 27.7487 34.193 26.3886 33.9592C25.0285 33.7255 23.7736 33.078 22.795 32.105C21.8204 31.1327 21.1724 29.8812 20.9409 28.5241C20.7094 27.167 20.9058 25.7715 21.503 24.531L20.134 23.184'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.182 33.191C1.56902 32.5749 1.22491 31.7411 1.22491 30.872C1.22491 30.0029 1.56902 29.1691 2.182 28.553L9.082 21.684C9.18318 21.5801 9.30416 21.4975 9.43778 21.4411C9.5714 21.3848 9.71496 21.3557 9.86 21.3557C10.005 21.3557 10.1486 21.3848 10.2822 21.4411C10.4158 21.4975 10.5368 21.5801 10.638 21.684L13.75 24.784C13.8516 24.8849 13.9323 25.005 13.9873 25.1372C14.0423 25.2695 14.0707 25.4113 14.0707 25.5545C14.0707 25.6977 14.0423 25.8396 13.9873 25.9718C13.9323 26.104 13.8516 26.2241 13.75 26.325L6.846 33.191C6.53954 33.4976 6.17568 33.7408 5.77521 33.9068C5.37473 34.0727 4.94549 34.1581 4.512 34.1581C4.0785 34.1581 3.64926 34.0727 3.24878 33.9068C2.84831 33.7408 2.48445 33.4976 2.178 33.191H2.182Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M24.42 1.781L33.55 10.881C33.9591 11.2931 34.1888 11.8503 34.1888 12.431C34.1888 13.0117 33.9591 13.5689 33.55 13.981L30.438 17.081C30.0233 17.4899 29.4644 17.7192 28.882 17.7192C28.2996 17.7192 27.7407 17.4899 27.326 17.081L18.196 7.981C17.7869 7.56889 17.5573 7.01172 17.5573 6.431C17.5573 5.85028 17.7869 5.29312 18.196 4.881L21.308 1.781C21.5114 1.57504 21.7537 1.41152 22.0208 1.29991C22.2879 1.1883 22.5745 1.13083 22.864 1.13083C23.1535 1.13083 23.4401 1.1883 23.7072 1.29991C23.9743 1.41152 24.2166 1.57504 24.42 1.781Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22.866 12.627L12.046 23.078'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_4_311'>
        <rect width='35.373' height='35.191' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default InsideIcon;
